import React, { useState, useEffect, useContext } from "react";
import "../../style.css";
import axios from "axios";
// import Pagination from "../../components/Pagination";
// import Search from "../../components/Search";
import CollectionFetchTable from "./CollectionFetchTable";
// import DomainDropdown from "../../components/DomainDropdown";
// import { Link } from "react-router-dom";
import { GlobalContext } from '../../context/GlobalContext';
// import ModelView from "./ModelView";
// import Modal from "../model/Modal";
// import Popup from "../popup/Popup"
// import Alert from "./Alert";
import PaginationModule from '../../pagination/PaginationModule';
import SelectInput from "../../components/select/SelectInput";
// import DatabaseDropdown from "../../components/dropdown/DatabaseDropdown";
import { toast } from "react-toastify";

const Table = () => {
  const { API_URL } = useContext(GlobalContext);

  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState("");
  const [transferData, setTransferData] = useState("");
  // eslint-disable-next-line
  const [selectAll, setSelectAll] = useState(false);
  const [domainURL, setDomainURL] = useState([]);
  const [URLs, setURLs] = useState([]);
  const [selectedURL, setSelectedURL] = useState("");
  // const [modalOpen, setModalOpen] = useState(false);
  // Get current posts
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  //const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filterData.slice(indexOfFirstPost, indexOfLastPost);
  const howManyPages = Math.ceil(filterData.length / postsPerPage);

  useEffect(() => {
    const Domain = async () => {
      if (window.location.pathname === '/') {
        try {
          const response = await axios.get(`${API_URL}/collectionsDomainURL`);
          setDomainURL(response.data);
        } catch (error) {
          console.log(error);
        }
      }
    };
    Domain();
    // eslint-disable-next-line
  }, []);

  // const handleDomainChange = (event) => {
  //   const selectedDomain = event.target.value;
  //   setSelectedDomain(selectedDomain);
  // };

  // Handlers
  const handleDomainChange = (selectedOption) => {
    setSelectedDomain(selectedOption ? selectedOption.value : '');
  };

  // const handleURLChange = (event) => {
  //   const selectedURL = event.target.value;
  //   setSelectedURL(selectedURL);
  // };

  const handleURLChange = (selectedOption) => {
    setSelectedURL(selectedOption ? selectedOption.value : '');
  };


  useEffect(() => {
    // Calculate the unique URLs for the selected domain
    const uniqueURLs = Array.from(
      new Set(
        domainURL
          .filter((state) => state.domain === selectedDomain)
          .map((state) => state.cur_url)
          .filter((url) => url && url.trim() !== "")
      )
    ).sort();

    setURLs(uniqueURLs);
  }, [data, selectedDomain, domainURL]);


  const handleSearch = async (e) => {
    e.preventDefault();
    setFilterData([])
    setData([])
    setLoading(true)
    
    if (!selectedDomain || selectedDomain.trim() === '') {
      toast.error("Please select a selected Domain first!")
      setLoading(false)
      return;
    }

    if (!selectedDomain || selectedURL.trim() === '') {
      toast.error("Please select a selected Current URL first!")
      setLoading(false)
      return;
    }
    const formData = {
      script: selectedURL,
      domain: selectedDomain,
    };

    const toastId = toast.loading("Data processing, please wait...");

    try {
      const response = await axios.post(`${API_URL}/collections`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        toast.update(toastId, {
          render: "Data Fetch successfully.",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        setData(response.data);
        setFilterData(response.data);
        setCurrentPage(1); // Reset the current page to 1
        console.log("value return: ", data)
      } else {
        console.error('Error searching database');
        toast.dismiss(); // Close all toasts
      }
    } catch (error) {
      console.error('Error searching database:', error);
      toast.update(toastId, {
        render: "Transfer failed.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setLoading(false)
    }
  };

  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const handleTransfer2Domain = async () => {
    if (selectedIds.length === 0) return;

    // if (!selectedDatabase || selectedDatabase.trim() === '') {
    //   showToast('error', 'Please select a Database first!', 'top', 5);
    //   return;
    // }

    const toastId = toast.loading("Data processing, please wait...");

    const selectedData = data.filter((item) => selectedIds.includes(item.id));
    console.log("selectedData length: ", selectedData.length);

    try {
      // eslint-disable-next-line
      const response = await axios.post(`${API_URL}/transferDomain_new`, { selectedData: selectedData, domain: selectedDomain });


      if (response.status === 200) {
        setTransferData(response.data)
        toast.update(toastId, {
          render: "Data transferred successfully.",
          type: "success",
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true,
          draggable: true,
          closeButton: true
        });
      }

      const resetData = data.map((item) => {
        if (selectedIds.includes(item.id)) {
          return {
            ...item,
            checked: false,
          };
        }
        return item;
      });

      const resetFilterData = filterData.map((item) => {
        if (selectedIds.includes(item.id)) {
          return {
            ...item,
            checked: false,
          };
        }
        return item;
      });
      setData(resetData);
      setFilterData(resetFilterData);
      setSelectedIds([]);
      setShowAlert(true);
    } catch (error) {
      console.log(error);
      const message = error.response?.data?.message || error.message || "Failed to transfer data. Please try again.";
      toast.update(toastId, {
        render: message,
        type: "error",
        isLoading: false,
        autoClose: 10000,
      });
    }
  };

  const handleSelectAll = () => {
    const currentPageIds = currentPosts.map(item => item.id);
    const allSelected = currentPageIds.every(id => selectedIds.includes(id));

    if (allSelected) {
      setSelectedIds(selectedIds.filter(id => !currentPageIds.includes(id)));
    } else {
      setSelectedIds([...selectedIds, ...currentPageIds]);
    }
  };

  const checkAll = () => {
    const confirmCheckAll = window.confirm("Are you sure you want to check all data for transfer?");

    if (confirmCheckAll) {
      const currentPageIds = filterData.map(item => item.id);
      const allSelected = currentPageIds.every(id => selectedIds.includes(id));

      if (allSelected) {
        setSelectedIds(selectedIds.filter(id => !currentPageIds.includes(id)));
      } else {
        setSelectedIds([...selectedIds, ...currentPageIds]);
      }
    }
  };

  // eslint-disable-next-line
  const handleRemoveText = (indexToRemove) => {
    setSelectedIds((prevSelectedIds) => {
      // Create a new array without the item at the specified index
      const updatedSelectedIds = prevSelectedIds.filter((_, index) => index !== indexToRemove);
      return updatedSelectedIds;
    });
  };



  const domainOptions = Array.from(new Set(domainURL.map(item => item.domain)))
    .filter(domain => domain && domain.trim() !== "")
    .sort()
    .map(domain => ({
      label: domain,
      value: domain
    }));

  // Transform URLs into options
  const urlOptions = [
    { value: 'all', label: 'Select All' }, // Keep "Select All" at the top
    ...URLs.map((url) => ({
      value: url,
      label: url,
    })),
  ];


  return (
    <>
      <div>
        <div className="container-fluid">
          <div className="row justify-content-between align-items-center">
            {/* <div id="collection-db-select" className="col-md-2">
              <DatabaseDropdown
                options={databaseOptions}
                value={databaseOptions.find(o => o.value === selectedDatabase) || null}
                onChange={handleDatabaseChange}
              />
            </div> */}
            <div id="collection-domain-select" className="col-md-3">
              <SelectInput
                options={domainOptions}
                value={domainOptions.find(o => o.value === selectedDomain) || null}
                onChange={handleDomainChange}
                placeholder="Search domain..."
                noOptionsMessage={() => 'No domains found'}
              />
            </div>
            <div id="collection-url-select" className="col-md-4">
              <SelectInput
                options={urlOptions}
                value={urlOptions.find(o => o.value === selectedURL) || null}
                onChange={handleURLChange}
                placeholder="Search URL..."
                noOptionsMessage={() => 'No URL found'}
              />
            </div>

            <div className="col-md-2">
              <button id="collection-search-data" className="btn btn-primary border py-2 px-4 fs-5" onClick={handleSearch} disabled={loading}>
                {loading ? "Loading..." : "Search"}
              </button>
            </div>

            <div className="d-flex col-md-3">
              {selectedDomain ?
                <button id="collection-checkbox-all" className="btn btn-light border py-2 fs-5" onClick={checkAll}>Check All</button>
                : ""}
              <div>
                {selectedIds.length > 0 && (
                  <button className="btn btn-light border text-danger ms-1 py-2 px-4 fs-5">
                    Selected: {selectedIds.length}
                  </button>

                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedIds.length > 0 && (
        <div className="container d-flex justify-content-end mt-2">
          <button id="collection-trans2domain" className="btn btn-light border py-2 px-2 fs-5 me-2" onClick={handleTransfer2Domain}>Transfer</button>
          <button id="collection-clear-checkbox-data" className="btn btn-light border py-2 px-2 fs-5" onClick={() => setSelectedIds([])}>Clear</button>
        </div>
      )}

      <div>
        {showAlert && (
          <pre className="p-3 mb-2 bg-alert-success text-white" role="alert">
            {transferData.message.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </pre>
        )}
      </div>
      {currentPosts.length > 0 ? (
        <div className="container-fluid mb-2">
          <CollectionFetchTable
            currentPosts={currentPosts}
            handleCheckboxChange={handleCheckboxChange}
            selectedIds={selectedIds}
            selectAll={selectAll}
            handleSelectAll={handleSelectAll}
          />
        </div>
      ) : (
        <div className="container-fluid text-center fs-4 py-4 mt-3 text-muted border">
          Apply filters to view the data.
        </div>
      )}

      <div>
        <PaginationModule totalPages={howManyPages} postsPerPage={postsPerPage} setPostsPerPage={setPostsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} />
      </div>

    </>
  );
};

export default Table;
